import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

interface WorkflowParams {
  dealNumber?: string
  decisionType?: string
  decisionReason?: string
  emailId?: string
}

/**
 * Reads workflow-related URL params from the current route and persists them
 * to sessionStorage. Must be called from within a route that contains these params.
 * URL params are stable for the component lifetime so the effect fires exactly once on mount.
 */
const useWorkflowParams = () => {
  const { dealNumber, decisionType, decisionReason, emailId } = useParams<WorkflowParams>()

  useEffect(() => {
    if (dealNumber) {
      sessionStorage.setItem('dealNumber', dealNumber)
      sessionStorage.setItem('decisionType', decisionType ?? '')
      sessionStorage.setItem('decisionReason', decisionReason ?? '')
      sessionStorage.setItem('emailId', emailId ?? '')
    }
  }, [dealNumber, decisionType, decisionReason, emailId])

  return { dealNumber, decisionType, decisionReason, emailId }
}

export default useWorkflowParams
